<template>
    <div class="mt-8 py-2">
        <div
            @click="$emit('closed')"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
            </span>
        </div>
        <div class="">
            <div class="mb-1 mx-4 flex justify-between">
                <div class="text-lg font-extrabold mb-1 pb-2 mx-2">{{ trans.list.list_ttl }}</div>
                <div
                    v-if="locationList.length !== 0"
                    class="badge text-lg ml-2 my-1 text-opacity-70 font-bold"
                >
                    {{ locationList.length
                    }}<span class="text-sm ml-1 mt-1">{{ trans.list.items_found }}</span>
                </div>
            </div>
            <div class="overflow-y-auto h-screen list-content-height">
                <div class="mb-96 sm:mb-20 sm:pb-12 pb-48">
                    <div v-if="locationList.length === 0" class="text-center mt-8 mx-4">
                        <div class="font-bold mb-2">{{ trans.list.not_found }}</div>
                        <p class="text-xs mb-1">{{ trans.list.not_found_notice1 }}</p>
                        <p class="text-xs">{{ trans.list.not_found_notice2 }}</p>
                    </div>
                    <div
                        v-else
                        class="category_item card card-compact border border-2 m-2 shadow m-3 hover:bg-base-200 transition-all duration-200 hover:scale-[1.02] z-100"
                        v-for="(location) in locationList"
                        :key="location.properties.id"
                        @click="
                            location.properties.layer_id && !isOnParcelMap
                                ? goToParcel(location)
                                : changeLocationDetail(location)
                        "
                    >
                        <figure>
                            <img
                                :src="
                                    location.properties.images.length > 0
                                        ? location.properties.images[0]
                                        : location.properties.marker_image_url
                                "
                                loading="lazy"
                                :class="[
                                    'h-40',
                                    'object-cover',
                                    'w-full',
                                    'bg-primary',
                                    location.properties.images.length > 0 ? '' : 'blur-img'
                                ]"
                            />
                        </figure>
                        <div class="avatar_base mx-3 absolute top-20">
                            <div class="avatar">
                                <div
                                    class="w-20 h-20 ring ring-primary ring-offset-base-100 ring-offset-2"
                                    :class="[ location.properties.marker_style !== 'square' && location.properties.marker_style !== 'icon' && location.properties.marker_style !== 'point' ? 'rounded-full' : 'rounded', currentState === 'half' ? 'w-14 h-14' : 'w-20 h-20',location.properties.marker_style === 'custom' ? 'rounded bg-base-100' : 'bg-primary',]"
                                >
                                    <img
                                        :src="location.properties.marker_image_url"
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div>
                                <h2 class="text-base font-bold text-base break-words txt_excerpt">
                                    {{ location.properties.title }}
                                </h2>
                                <p class="text-base-content/70 text-sm break-words txt_excerpt mb-1">
                                    {{ location.properties.sub_title }}
                                </p>
                                <p class="btn btn-xs disabled rounded-full normal-case">
                                    {{ location.properties.category.title }}
                                </p>
                                <div v-if="location.properties.layer_id && parcels.length > 0" class="mt-1">
                                    <div class="text-primary text-xs">
                                        {{ getParcelTitle(location.properties.layer_id) }}
                                    </div>
                                    <div class="text-primary text-xs">
                                        {{ getLayerTitle(location.properties.layer_id) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="locationList.length === 100" class="text-center mt-8 mx-4">
                        <div class="font-bold mb-2">{{ trans.list.show_maximum }}</div>
                        <p class="text-xs mb-1">{{ trans.list.show_maximum_notice }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['trans', 'mapId', 'locale'],
    props: {
        locationList: {
            type: Array,
            required: true
        },
        parcelResource: {
            type: Array,
            default: []
        },
        isOnParcelMap: {
            type: Boolean,
            default: false
        },
        currentLayer: {
            type: Object,
            default: function() {
                return null
            }
        },
        currentState: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            parcels: []
        }
    },
    created() {
        if (this.isOnParcelMap) {
            this.getParcels();
        } else {
            this.parcels = this.parcelResource;
        }
    },
    methods: {
        isOnCurrentLayer(layerId) {
            return this.currentLayer && this.currentLayer.id == layerId
        },
        getParcels() {
            axios
                .get(`/api/maps/${this.mapId}/parcels?locale=${this.locale}`)
                .catch(function (error) {
                    console.log(error.toJSON());
                })
                .then((response) => {
                    this.parcels = response.data;
                });
        },
        changeLocationDetail(payload) {
            this.$emit('changedLocationDetail', payload);
            if (this.isOnParcelMap && payload.properties.layer_id && !this.isOnCurrentLayer(payload.properties.layer_id)) {
                this.$emit('changedLayerId', payload.properties.layer_id)
            }
        },
        goToParcel(location) {
            const parcelId = this.parcels.find((el) =>
                el.layers.some((layer) => layer.id == location.properties.layer_id)
            ).id;
            const mapHashID = window.location.pathname.split('/')[2];
            window.open(`/maps/${mapHashID}/parcels/${parcelId}?s=${location.properties.id}`, '_blank');
        },
        getParcelTitle(layerId) {
            var found = this.parcels.find((el) =>
                el.layers.some((layer) => layer.id == layerId)
            );

            return found.title;
        },
        getLayerTitle(layerId) {
            var parcelLength = this.parcels.length;
            for (let i = 0; i < parcelLength; i++) {
                const layers = this.parcels[i].layers;
                const layerLength = layers.length;
                for (let j = 0; j < layerLength; j++) {
                    const layer = layers[j];
                    if (layer.id == layerId) {
                        return layer.title
                    }
                }
            }
        }
    }
};
</script>

<style>
.blur-img {
    -webkit-filter: blur(2px);
    -moz-filter: blur(2px);
    -o-filter: blur(2px);
    -ms-filter: blur(2px);
    filter: blur(2px);
}
.list-content-height {
    padding-bottom: 10rem;
}
.txt_excerpt {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media screen and (max-width: 639px) {
    .list-content-height {
        min-height: 40rem;
        padding-bottom: 40rem;
    }
}
</style>